import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate, useParams } from 'react-router-dom';

const EditPosAlterationDeliveries = () => {
    const [counter, setCounter] = useState('');
    const [delivery_no, setDeliveryNo] = useState('');
    const [date, setDate] = useState('');
    const [customer, setCustomer] = useState('');
    const [order_no, setOrderNo] = useState('');
    const [trial_date, setTrialDate] = useState('');
    const [delivery_date, setDeliveryDate] = useState('');
    const [description, setDescription] = useState('');
    const [no_of_pcs, setNoOfPcs] = useState('');
    const [charges_on_delivery, setChargesOnDelivery] = useState('');
    const [alteration_description, setAlterationDescription] = useState('');
    const navigate = useNavigate();
    const { id } = useParams(); // Get the ID from the URL parameters

    // Fetch the existing alteration delivery data when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}posalterationdeliveries/${id}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    const deliveryData = data.data;
                    // Pre-fill the form with the fetched data
                    setCounter(deliveryData.counter);
                    setDeliveryNo(deliveryData.delivery_no);
                    setDate(deliveryData.date);
                    setCustomer(deliveryData.customer);
                    setOrderNo(deliveryData.order_no);
                    setTrialDate(deliveryData.trial_date);
                    setDeliveryDate(deliveryData.delivery_date);
                    setDescription(deliveryData.description);
                    setNoOfPcs(deliveryData.no_of_pcs);
                    setChargesOnDelivery(deliveryData.charges_on_delivery);
                    setAlterationDescription(deliveryData.alteration_description);
                }
            })
            .catch((error) => console.error('Error fetching delivery data:', error));
    }, [id]);

    // Handle form submit (update the alteration delivery)
    const handleSubmit = (event) => {
        event.preventDefault();

        const updatedDelivery = {
            counter,
            delivery_no,
            date,
            customer,
            order_no,
            trial_date,
            delivery_date,
            description,
            no_of_pcs,
            charges_on_delivery,
            alteration_description,
        };

        // Send PUT request to update the alteration delivery
        fetch(`${BASE_URL}posalterationdeliveries/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedDelivery),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    // Navigate to the list page or show success message
                    alert('Alteration delivery updated successfully');
                    navigate('/PosAlterationDeliveriesList');
                } else {
                    alert('Failed to update delivery');
                }
            })
            .catch((error) => console.error('Error updating delivery:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Alteration Delivery</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Edit Alteration Delivery</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="counter" className="form-label">Counter</label>
                                        <input
                                            type="text"
                                            id="counter"
                                            className="form-control"
                                            value={counter}
                                            onChange={(e) => setCounter(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="delivery_no" className="form-label">Delivery No</label>
                                        <input
                                            type="text"
                                            id="delivery_no"
                                            className="form-control"
                                            value={delivery_no}
                                            onChange={(e) => setDeliveryNo(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="date" className="form-label">Date</label>
                                        <input
                                            type="date"
                                            id="date"
                                            className="form-control"
                                            value={date}
                                            onChange={(e) => setDate(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="customer" className="form-label">Customer</label>
                                        <input
                                            type="text"
                                            id="customer"
                                            className="form-control"
                                            value={customer}
                                            onChange={(e) => setCustomer(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="order_no" className="form-label">Order No</label>
                                        <input
                                            type="text"
                                            id="order_no"
                                            className="form-control"
                                            value={order_no}
                                            onChange={(e) => setOrderNo(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="trial_date" className="form-label">Trial Date</label>
                                        <input
                                            type="date"
                                            id="trial_date"
                                            className="form-control"
                                            value={trial_date}
                                            onChange={(e) => setTrialDate(e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="delivery_date" className="form-label">Delivery Date</label>
                                        <input
                                            type="date"
                                            id="delivery_date"
                                            className="form-control"
                                            value={delivery_date}
                                            onChange={(e) => setDeliveryDate(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <input
                                            type="text"
                                            id="description"
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="no_of_pcs" className="form-label">No of Pieces</label>
                                        <input
                                            type="number"
                                            id="no_of_pcs"
                                            className="form-control"
                                            value={no_of_pcs}
                                            onChange={(e) => setNoOfPcs(e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="charges_on_delivery" className="form-label">Charges on Delivery</label>
                                        <input
                                            type="number"
                                            id="charges_on_delivery"
                                            className="form-control"
                                            value={charges_on_delivery}
                                            onChange={(e) => setChargesOnDelivery(e.target.value)}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="alteration_description" className="form-label">Alteration Description</label>
                                        <input
                                            type="text"
                                            id="alteration_description"
                                            className="form-control"
                                            value={alteration_description}
                                            onChange={(e) => setAlterationDescription(e.target.value)}
                                        />
                                    </div>

                                    <div className="mb-3 text-end">
                                        <button type="submit" className="btn btn-primary">Update Delivery</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditPosAlterationDeliveries;
